import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { PermissionTypeDTO } from "../dtos/PermissionTypeDTO";
import { STALE_TIME_MEDIUM } from "../query/query.constants";
import { useQuery } from "@tanstack/vue-query";
const PERMISSION_TYPE_STALE_TIME = STALE_TIME_MEDIUM;
export function usePermissionTypes() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["permission-types"],
        queryFn: async () => (await seedgreenAPI.get("v2/PermissionType")).data,
        staleTime: PERMISSION_TYPE_STALE_TIME,
        select: (data) => {
            try {
                return (data?.map((types) => new PermissionTypeDTO(types)) ?? []);
            }
            catch (error) {
                console.error("query/permission-type select ERROR", error);
            }
        },
    });
    return {
        permissionTypes: query.data,
        ...query,
    };
}
